import { BaseEntity, getCachedSolarSystemEntity, getCachedStructureEntity, isEntityOfType } from ".";
import { IGet_characters_character_id_assets_200_ok } from "../service/esiclient";
import { getCachedStationEntity } from "./StationEntityCache";
import { getCachedAssetEntity } from "./AssetEntityCache";
import { getCachedCharacterEntity } from "./CharacterEntityCache";

export class AssetEntity extends BaseEntity {
  constructor(id: number, props: any, character_id: number) {
    super(id, props);
    this._dataTypeName = "Character Asset";
    this._character_id = character_id;
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<IGet_characters_character_id_assets_200_ok> = this.props;

    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      const characterEntity = await getCachedCharacterEntity(this._character_id);
      if (characterEntity !== null) {
        const resolvedEntity = await characterEntity.toJson();
        if (resolvedEntity.text) {
          entity.properties["owner"] = { type: Excel.CellValueType.string, basicValue: resolvedEntity.text };
        }
      }
      // - Id
      delete entity.properties["item_id"];
      // - Text and Image
      if (entity.properties["type"]) {
        const typeEntity = entity.properties["type"] as Excel.EntityCellValue;
        if (typeEntity && typeEntity.properties) {
          // Text
          entity.text = typeEntity.properties.name.basicValue as string;
          // Image
          if (Object.prototype.hasOwnProperty.call(typeEntity.properties, "image")) {
            entity.properties["image"] = typeEntity.properties["image"];
          }
        }
      }
      // - Location
      if (props.location_id && props.location_type) {
        if (props.location_type === "station") {
          // Location is a station
          const stationEntity = await getCachedStationEntity(props.location_id);
          if (stationEntity !== null) {
            entity.properties["location"] = await stationEntity.toJson(true);
            entity.properties["final_location"] = await stationEntity.toJson(true);
            delete entity.properties["location_id"];
          }
        } else if (props.location_type === "item" && props.item_id) {
          // Location is a slot on an item (asset)
          const assetEntity = await getCachedAssetEntity(props.location_id);
          if (assetEntity !== null) {
            entity.properties["location"] = await assetEntity.toJson();
            const nextAssetEntity = await getCachedAssetEntity(props.location_id);
            if (nextAssetEntity != null) {
              const nextAssetIs = await nextAssetEntity.toJson();
              if (nextAssetIs.properties?.final_location) {
                if (nextAssetIs.properties?.location_type.basicValue == "solar_system") {
                  entity.properties["final_location"] = nextAssetIs;
                } else {
                  entity.properties["final_location"] = nextAssetIs.properties?.final_location;
                }
              }
            } else {
              if (assetEntity.props.location_type === "station") {
                const finalStationEntity = await getCachedStationEntity(assetEntity.props.location_id);
                if (finalStationEntity !== null) {
                  entity.properties["final_location"] = await finalStationEntity.toJson(true);
                }
              } else {
                const structureEntity = await getCachedStructureEntity(
                  assetEntity.props.location_id,
                  this._character_id
                );
                if (structureEntity !== null) {
                  entity.properties["final_location"] = await structureEntity.toJson(true);
                } else {
                  entity.properties["final_location"] = {
                    type: Excel.CellValueType.formattedNumber,
                    basicValue: props.location_id,
                    numberFormat: "##0",
                  };
                }
              }
            }
            delete entity.properties["location_id"];
          } else {
            //possibly private structure
            const structureEntity = await getCachedStructureEntity(props.location_id, this._character_id);
            if (structureEntity !== null) {
              entity.properties["location"] = await structureEntity.toJson(true);
              entity.properties["final_location"] = await structureEntity.toJson(true);
              delete entity.properties["location_id"];
            } else {
              entity.properties["location"] = {
                type: Excel.CellValueType.formattedNumber,
                basicValue: props.location_id,
                numberFormat: "##0",
              };
              entity.properties["final_location"] = {
                type: Excel.CellValueType.formattedNumber,
                basicValue: props.location_id,
                numberFormat: "##0",
              };
              delete entity.properties["location_id"];
            }
          }
        } else if (props.location_type === "solar_system" && props.location_id) {
          const solarSystemEntity = await getCachedSolarSystemEntity(props.location_id);
          if (solarSystemEntity != null) {
            entity.properties["location"] = await solarSystemEntity.toJson();
            entity.properties["final_location"] = await solarSystemEntity.toJson();
          }
        }
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        // title: { property: "name" },
      },
    };

    // - Image
    if (
      entity.layouts &&
      entity.layouts.card &&
      entity.properties &&
      Object.prototype.hasOwnProperty.call(entity.properties, "image")
    ) {
      entity.layouts.card.mainImage = { property: "image" };
    }
    return entity;
  }
}

export function isAssetEntity(entity: any): boolean {
  return isEntityOfType(entity, "Asset");
}
